






import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import Form from "@/views/Service/TimeTracking/Management/Customers/Form.vue";
import ITimeTrackingCustomer from "@/models/TimeTracking/ITimeTrackingCustomer";


const NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS: string = 'timeTrackingManagementCustomers';
const RESOURCE_TIME_TRACKING_MANAGEMENT_CUSTOMERS: string = 'tt/management/customers';
@Component({
  components: {Form}
})
export default class Edit extends Vue {
  public name: string = "List";

  @Action('createItem', {namespace: NAMESPACE_TIME_TRACKING_MANAGEMENT_CUSTOMERS}) createItem: any;

  private onSubmit(data: ITimeTrackingCustomer) {

    // removed console_log
    this.createItem({
      resource: RESOURCE_TIME_TRACKING_MANAGEMENT_CUSTOMERS,
      data: data
    }).then((response: any) => {

      // removed console_log
      this.$router.push({name: 'TimeTracking-Management-Customers'});

    });

  }

}
